import React from 'react'

const UserInfo: React.FC = () => {
  return (
    <div>
      <h1>Create User</h1>
      <p>This is the UserInfo page for user creation and management.</p>
    </div>
  )
}

export default UserInfo
